<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-4 mx-0">
          <vs-button
            @click="onShowCreateAndModifyPopup('create')"
            class="bg_l_green"
            v-has-permission="permission132"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("CreateNewBrand") }}
          </vs-button>
        </div>
        <div class=".">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('BrandName'), sort: 'Name' },
              { title: $t('PersianName'), sort: 'PersianName' },
              { title: $t('CreateOn'), sort: 'CreateOn' },
              { title: $t('Action') },
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 25%">
                {{ row.name }}
              </td>
              <td style="width: 25%">
                {{ row.persianName }}
              </td>
              <td style="width: 25%">
                {{ row.createOn.split("   ")[0] }}<br />{{
                  row.createOn.split("   ")[1]
                }}
              </td>
              <td style="width: 25%">
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  @click="onShowCreateAndModifyPopup('edit', row)"
                  class="ml-4 d-inline"
                  v-has-permission="permission133"
                ></vs-button>
                <vs-button
                  radius
                  color="danger"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="removeBrand(row.id)"
                  class="d-inline"
                  v-has-permission="permission134"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
    <create-and-modify-popup
      :show="isShowCreateAndModifyPopup"
      :model="selectedBrand"
      @finish="onfinish"
      @close="closeCreateAndModifyPopup"
    ></create-and-modify-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
// import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import CreateAndModifyPopup from "./CreateAndModifyPopup.vue";

export default {
  components: {
    CreateAndModifyPopup,
    DataGrid,
  },
  data() {
    return {
      permission132: "CreateBrand",
      permission133: "ModifyBrand",
      permission134: "DeleteBrand",
      isShowCreateAndModifyPopup: false,
      selectedBrand: {},
      gridDataSource: {
        type: "app",
        service: "ProductManagement/api/BrandsQuery",
      },
      gridSearchData: {},
    };
  },

  methods: {
    ...mapActions({
      deleteBrand: "brand/delete",
    }),
    onShowCreateAndModifyPopup(type, selectBrand = {}) {
      if (type == "edit") this.createModelForModify(selectBrand);
      else this.selectedBrand = selectBrand;
      this.isShowCreateAndModifyPopup = true;
    },

    createModelForModify(model) {
      this.selectedBrand = {
        id: model.id,
        name: model.name,
        persianName: model.persianName,
        description: model.description,
        metaDescription: model.metaDescription,
        metaKeywords: model.metaKeywords,
        logoUri: model.logoUri,
        coverUri: model.coverUri,
      };
    },
    removeBrand(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.deleteBrand(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeCreateAndModifyPopup() {
      this.isShowCreateAndModifyPopup = false;
    },
    onfinish() {
      this.closeCreateAndModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
